<template>
  <v-container fluid pa-0 fill-height>

    <v-layout align-center>

      <v-flex md6>

          <v-sheet color="transparent" class="text-xs-center">
            <div class="title primary--text">Zoomryde</div>
            <div class="subheading gray--text text--lighten-1">Login or Signup to continue</div>
            <div id="firebaseui-auth-container"></div>
          </v-sheet>

      </v-flex>
      
      <v-flex md6 class='hidden-sm-and-down'>
        <v-img :src="require('../assets/login.jpg')" class="hero white--text" 
          gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)">
          <v-container fill-height fluid>
            <v-layout align-center>
              <v-flex class="text-xs-center">
                <div class="display-2">Event Management Tool</div>
                <br />
                <span class="subheading">Plan and get people where you want them, when you want them.</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-img>
      </v-flex>

    </v-layout>

  </v-container>
</template>
<script>
  import * as firebaseui from 'firebaseui'
  const fb = require('../firebaseConfig');

  export default {
    name: 'login', 
    mounted(){
      var uiConfig = {
        signInSuccessUrl: process.env.VUE_APP_ROOT_URL+'/dashboard', 
        signInOptions: [
          fb.firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          fb.firebase.auth.EmailAuthProvider.PROVIDER_ID
        ]
      };

      let ui = firebaseui.auth.AuthUI.getInstance();

      if(!ui) {
        ui = new firebaseui.auth.AuthUI(fb.firebase.auth());
      }

      ui.start('#firebaseui-auth-container', uiConfig);

    },
    data() {
      return {

      }
    }
  }

</script>
<style>
  .hero{
    height: calc(100vh - 120px);
  }
</style>